export default __webpack_public_path__ + "static/media/ranking.0dd4252b.svg";